import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { UploadFileService } from '../../services/upload-file.service';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
})
export class UploadFileComponent {
  currentFile?: File;
  isFileSelected: boolean = false;
  message = '';
  fileName = 'Select File';

  constructor(private uploadFileService: UploadFileService) {}

  selectFile(event: any): void {
    this.isFileSelected = true;
    if (event.target.files && event.target.files[0]) {
      const file: File = event.target.files[0];
      this.currentFile = file;
      this.fileName = this.currentFile.name;
    } else {
      this.fileName = 'Select File';
    }
  }

  upload(): void {
    this.message = '';

    if (this.currentFile) {
      this.uploadFileService
        .uploadFile(this.currentFile)
        .subscribe((err: any) => {
          console.log(err);
          if (err.error && err.error.message) {
            this.message = err.error.message;
          } else {
            this.message = 'Could not upload the file!';
          }
          this.currentFile = undefined;
        });
    }
  }
}
